// extracted by mini-css-extract-plugin
export default {"link":"PQ-z","disabled":"QQ-z"};